/* eslint-disable */
import { Theme, makeStyles, createStyles } from "@material-ui/core";

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    treeView: {
      paddingTop: theme.spacing(2),
      userSelect: "none",
      height: "100%",
      flexGrow: 1,
      maxWidth: 292,
      width: "100%",
    },
    treeGroup: {
      padding: theme.spacing(1, 0),
    },
  })
);

export const useParentStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {},
    selected: {
      "& $content": {
        background: "none !important",
      },
      "& $label": {
        background: "none !important",
      },
    },
    content: {
      borderRadius: "4px",
      padding: "6px",
      height: "32px",
    },
    label: {
      color: "rgba(39, 58, 57, 0.8)",
      fontSize: "12px",
      lineHeight: "100%",
      fontWeight: "bold",
      background: "none !important",
    },
  })
);

export const useItemStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      marginBottom: "2px",
      width: "100%",
      "& $content:hover": {
        background: "rgba(51, 51, 51, 0.05)",
      },
    },
    item: {
      display: "flex",
      alignItems: "center",
      width: "calc(100% - 32px)",
      maxWidth: "220px"
    },
    iconFavourite: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      cursor: "pointer",
      flex: "0 0 32px",
      width: "32px",
      height: "32px",
      marginLeft: theme.spacing(0.5),
      borderRadius: "4px",
      border: 0,
      padding: 0,
      minWidth: "fit-content",
      "& svg": {
        display: "block",
        width: "20px",
        height: "20px",
      },
      "&:disabled": {
        border: 0,
      },
      "&:hover": {
        background: "rgba(51, 51, 51, 0.05)",
      },
    },
    content: {
      borderRadius: "4px",
      padding: "6px",
      marginLeft: "-32px",
      paddingLeft: "28px",
      height: "32px",
      width: "calc(100% + 32px)",
    },
    label: {
      minWidth: "200px",
      color: "rgba(39, 58, 57, 0.8)",
      fontSize: "12px",
      lineHeight: "100%",
      fontWeight: "bold",
      background: "none !important",
      whiteSpace: "nowrap",
      overflow: "hidden",
      textOverflow: "ellipsis",
    },
    selected: {
      "& $content": {
        background: "rgba(101, 172, 30, 0.2)",
      },
      "& $label": {
        background: "none !important",
        color: "#65AC1E",
      },
    },
  })
);

export const useDisabledItemStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      marginBottom: "2px",
      "& $content:hover": {
        background: "rgba(51, 51, 51, 0.05)",
      },
    },
    content: {
      borderRadius: "4px",
      padding: "6px",
      marginLeft: "-32px",
      paddingLeft: "28px",
      height: "32px",
      width: "calc(100% + 32px)",
    },
    label: {
      color: "rgba(39, 58, 57, 0.4)",
      fontSize: "12px",
      lineHeight: "100%",
      fontWeight: "bold",
      background: "none !important",
    },
    selected: {
      "& $content": {
        background: "rgba(101, 172, 30, 0.2)",
      },
      "& $label": {
        background: "none !important",
        color: "#65AC1E",
      },
    },
  })
);
